module.exports = __webpack_public_path__ + "static/img/logo@3x.0bb2b3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/project-logos/logo@3x.png
// module id = FkQY
// module chunks = 0